import { Params } from './types';

export const getName = (params: Params) => {
  if (params.tab == 'pearson_correlation')
    return `Correlation Between Asset Risk and Abs. ${params.window}-Day Forward Returns`;
  if (params.tab == 'rank_correlation')
    return `Rank Correlation Between Asset Risk and Abs. ${params.window}-Day Forward Returns`;
  return 'Cross-sectional Correlation';
};
